var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftRamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 547,
    height: 231,
    viewBox: "0 0 547 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.5 176.074L67.1634 121.104L57.1635 77.1073L229.5 107.072L229.5 145.074L229.5 176.074Z",
    fill: "#BA1610"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 230.453L231 178.453L231 108.454L408 139.453L404.5 194.953L404.5 230.453Z",
    fill: "#BA1610"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5007 68.5002L19 91L43.9977 106.581L64.4977 120.083L59.498 97.5834L54.9978 76.5826L17.5007 68.5002Z",
    fill: "#BA1610"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.828 63.0798L53.9992 74.8105L229.999 104.575L356 66.5753L140.828 63.0798Z",
    fill: "#D2312C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360.999 65.7698L235 104.506L409 135.77L546.5 77.2706L360.999 65.7698Z",
    fill: "#D2312C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4966 61.0761L17.4995 67.4999L51.5 74L133.497 62.0791L42.4966 61.0761Z",
    fill: "#D2312C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49805 63.5L5 67.5L7.68026 75.746L18.4928 90.5351L17.6597 78.535L16.6842 68.5351L5.49805 63.5Z",
    fill: "#BA1610"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6708 60.0516L5.5006 63.0001L16.5 67.5L35.6782 62.193L26.6708 60.0516Z",
    fill: "#D2312C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftRamp);
export default __webpack_public_path__ + "static/media/leftRamp.9662d05804860ad805f0fc9997c12da2.svg";
export { ForwardRef as ReactComponent };